import { render, staticRenderFns } from "./TkHotelCheckinGuidance.vue?vue&type=template&id=796c31fa&"
import script from "./TkHotelCheckinGuidance.vue?vue&type=script&lang=js&"
export * from "./TkHotelCheckinGuidance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports